import { getMediaQuery } from '../utils';

export default {
  data() {
    return {
      breakpointValue: '',
      currentBreakpoint: '',
      isCompletelyLoaded: false,
    };
  },
  methods: {
    updateBreakpointValue(mediaQueryList) {
      this.currentBreakpoint = '';
      if (mediaQueryList.matches) {
        this.breakpointValue = this.breakpointRefSize;
      } else {
        this.breakpointValue = this.breakpointSmallerSize;
      }
    },
  },
  mounted() {
    const mediaQuery = getMediaQuery(this.breakpointRefSize);
    const mediaQueryList = window.matchMedia(mediaQuery);

    this.updateBreakpointValue(mediaQueryList);
    this.currentBreakpoint = this.breakpointValue;

    mediaQueryList.addEventListener('change', mql => {
      this.updateBreakpointValue(mql);
    });

    this.$root.$on('autocompleteInstancedDestroyed', () => {
      this.currentBreakpoint = this.breakpointValue;
    });

    this.$root.$on('initialHitsRequestCompleted', () => {
      this.isCompletelyLoaded = true;
    });
  },
};
